import { render } from "./customOnOfficeFields.vue?vue&type=template&id=68603a2b&ts=true"
import script from "./customOnOfficeFields.vue?vue&type=script&lang=ts"
export * from "./customOnOfficeFields.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__